module.exports = __webpack_public_path__ + "ed689228f4406fbfa8077930ce2eaafc.png";


//////////////////
// WEBPACK FOOTER
// ../assets/neuron-settings.png
// module id = 519
// module chunks = 0